<style>
.UsersTable .table__container--panel {
  background-color: #f5f7f7;
  color: #757575;
  border: 1px 1px 0px 1px solid #bdc3c7;
  border-width: 1px 1px 0px 1px;
  border-style: solid;
  border-color: rgb(189, 195, 199);
}
.UsersTable .table__container--panel p {
  font-size: 12px;
}
.UsersTable .table__container--separator {
  border-right: 1px solid rgba(189, 195, 199, 0.5);
  content: " ";
  height: 8px;
  margin-top: 8px;
  position: relative;
  right: 0;
  top: 0;
}
.UsersTable .table__container--filter {
  margin: 3px;
  border: 1px solid rgba(189, 195, 199, 0.5);
  font-size: 12px;
}
</style>

<template>
  <v-layout
    row
    fill-height
    wrap
    class="UsersTable"
  >
    <v-layout
      class="table__container--panel"
      wrap
    >
      <v-icon
        style="padding-left: 10px"
        @click="show('AddUser')"
        title="Dodaj użytkownika"
      >person_add</v-icon>
      <v-layout
        align-right
        justify-end
      >
        <div style="margin-top: auto; margin-bottom: auto;">
          <p style="line-height:29px">Liczba wyników: {{numberFiltered}}/{{numberAll}}</p>
        </div>
        <input
          type="text"
          class="table__container--filter"
          v-model="filter"
          placeholder="Treść filtra"
        >
      </v-layout>
      <div class="table__container--separator"></div>
    </v-layout>
    <ag-grid-vue
      style="width: 100%; height: 90%;"
      class="ag-theme-balham"
      :gridOptions="gridOptions"
    ></ag-grid-vue>
  </v-layout>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";

export default {
  name: "App",
  data: () => ({
    tableTitle: "usersTable",
    filter: "",
    inspectionsTaskFiltered: undefined,
    numberAll: 0,
    numberFiltered: 0
  }),
  components: {
    AgGridVue,
    Buttons: {
      template:
        `<span>\
          <v-icon small @click="removeUser" title="Usuń użytkownika">delete</v-icon>\
          <v-icon small @click="unlockUserAcc" title="Odblokuj konto użytkownika">lock_open</v-icon>\
          <v-icon small @click="changePassword" title="Zmień hasło użytkownika">lock</v-icon>\
          <v-icon small @click="managePermissions" title="Zarządzaj uprawnieniami">create</v-icon>\
          <v-icon v-if="!params.data.gname" small @click="assignUser" title="Przypisz użytkownika do grupy">group_add</v-icon>\
          <v-icon v-if="params.data.gname" small @click="changeUserGroup" title="Przypisz użytkownika do innej grupy">compare_arrows</v-icon>\
        </span>`,
      computed: {
        activeModals() {
          return this.$store.getters.getModalsList;
        }
      },
      methods: {
        removeUser() {
          let id = this.params.data.id;
          const self = this;
          this.$emit("confDialogOpened", true);
          self.$modal.show("dialog", {
            title: `Usuwanie użytkownika ${this.params.data.name}`,
            text: "Czy na pewno chcesz usunąć użytkownika?",
            buttons: [
              {
                title: "NIE",
                handler: () => {
                  self.$modal.hide("dialog");
                  return;
                }
              },
              {
                title: "TAK",
                default: true,
                handler: () => {
                  self.$store.dispatch("removeUser", id).then(success => {
                    if(success) {
                      self.$root.$emit(
                        "showSnackbar",
                        "success",
                        "Pomyślnie usunięto użytkownika"
                      );
                      self.params.api.selectIndex(self.params.node.rowIndex);
                      let selectedData = self.params.api.getSelectedRows();
                      self.params.api.updateRowData({remove: selectedData});
                      self.$root.$emit("userDeleted");
                    } else {
                      self.$root.$emit(
                        "showSnackbar",
                        "red",
                        "Podczas usuwania użytkownika wystąpił błąd"
                      );
                    }
                  });
                  self.$modal.hide("dialog");
                }
              }
            ]
          });
        },
        assignUser() {
          if(this.activeModals.indexOf("AssignUserToGroup") == -1) {
            this.$store.commit("addModal", "AssignUserToGroup");
            this.$modal.show("AssignUserToGroup");
            this.$store.commit("setCurrentUserId", this.params.data.id);
          }
        },
        changeUserGroup() {
          if(this.activeModals.indexOf("ChangeUserGroup") == -1) {
            this.$store.commit("addModal", "ChangeUserGroup");
            this.$modal.show("ChangeUserGroup");
            this.$store.commit("setCurrentUserId", this.params.data.id);
          }
        },
        managePermissions() {
          const self = this;
          if(this.params.data.gname == null) {
            this.$store.commit(
              "setCurrentUserGroup",
              this.params.data.usergroup
            );
            this.$store.commit("setCurrentUsername", this.params.data.name);
            if(this.activeModals.indexOf("ModifyPermissions") == -1) {
              this.$store.commit("addModal", "ModifyPermissions");
              this.$modal.show("ModifyPermissions");
            }
          } else {
            this.$modal.show("dialog", {
              title: `Uprawnienia grupy`,
              text: "W celu edycji uprawnień grupy przejdź do zakładki GRUPY.",
              buttons: [
                {
                  title: "Zamknij",
                  handler: () => {
                    self.$modal.hide("dialog");
                    return;
                  }
                }
              ]
            });
          }
        },
        changePassword() {
          if(this.activeModals.indexOf("ChangePasswordUser") == -1) {
            this.$store.commit("addModal", "ChangePasswordUser");
            this.$modal.show("ChangePasswordUser");
            this.$store.commit("setCurrentUserId", this.params.data.id);
          }
        },
        unlockUserAcc() {
          const self = this;
          this.$emit("confDialogOpened", true);
          self.$modal.show("dialog", {
            title: `Odblokowywanie konta użytkownika ${this.params.data.name}`,
            text: "Czy na pewno chcesz odblokować konto użytkownika?",
            buttons: [
              {
                title: "NIE",
                handler: () => {
                  self.$modal.hide("dialog");
                  return;
                }
              },
              {
                title: "TAK",
                default: true,
                handler: () => {
                  self.$store.dispatch('modifyUser', {
                    body: {
                      "failed_logins": 0
                    },
                    uid: self.params.data.id
                  }).then(r => {
                    if(r) {
                      self.$root.$emit(
                        "showSnackbar",
                        "success",
                        "Pomyślnie odblokowano konto użytkownika"
                      );
                    }
                  })
                  self.$modal.hide("dialog");
                }
              }
            ]
          });

        }
      }
    }

  },
  computed: {
    gridOptions() {
      let gridOptions = {
        rowData: this.loadData(),
        overlayLoadingTemplate:
          '<span class="ag-overlay-loading-center">Trwa ładowanie danych</span>',
        columnDefs: this.columnDefs,
        enableSorting: "true",
        enableFilter: "true",
        onFilterModified: this.filteredNumber,
        enableColResize: "true",
        onGridReady: this.onGridReady,
        onColumnMoved: this.onColumnMoved,
        onColumnResized: this.onColumnMoved,
        onFilterChanged: this.filterColumn,
        context: {
          componentParent: this
        },
        localeText: {
          contains: "Zawiera",
          notContains: "Nie zawiera",
          equals: "Równa się",
          notEqual: "Nie równa się",
          startsWith: "Zaczyna się",
          endsWith: "Kończy się",
          noRowsToShow: "Brak danych"
        }
      };
      return gridOptions;
    },
    activeModals() {
      return this.$store.getters.getModalsList;
    },
    users() {
      return this.$store.getters.getUsers;
    }
  },
  beforeMount() {
    let dict = [
      {
        headerName: "Nazwa",
        field: "name"
      },
      {
        headerName: "Grupa",
        field: "gname",
        valueFormatter: this.groupFormatter
      }
    ];
    this.columnDefs = [];
    dict.forEach(field => {
      this.columnDefs.push(field);
    });
    this.columnDefs.push({
      headerName: "Opcje",
      cellRendererFramework: "Buttons"
    });
  },
  methods: {
    filterColumn() {
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length.toString();
    },
    groupFormatter(params) {
      if(params.data.gname == null) {
        return "Brak";
      }
    },
    show(title) {
      if(this.activeModals.indexOf(title) == -1) {
        this.$store.commit("addModal", title);
        this.$modal.show(title);
      }
    },
    filteredNumber() {
      this.numberFiltered = this.gridOptions.api.getModel().getRowCount();
    },
    loadData() {
      const self = this;
      this.$store.dispatch("getUsers").then(success => {
        if(success) {
          self.numberAll = self.users.length;
          self.numberFiltered = self.numberAll;
          self.gridOptions.api.setRowData(self.users);
          self.gridOptions.api.sizeColumnsToFit();
        }
      });
    },
    onColumnMoved(params) {
      const columnState = JSON.stringify(
        this.gridOptions.columnApi.getColumnState()
      );
      localStorage[this.tableTitle] = columnState;
    },
    onGridReady(params) {
      if(localStorage[this.tableTitle]) {
        const columnState = JSON.parse(localStorage[this.tableTitle]);
        if(columnState) {
          this.gridOptions.columnApi.setColumnState(columnState);
        }
      }
    }
  },
  watch: {
    filter(nV) {
      this.gridOptions.api.setQuickFilter(nV);
      this.numberFiltered = this.gridOptions.api.getModel().rootNode.childrenAfterFilter.length;
    }
  },
  mounted() {
    this.$root.$on("newUserAdded", this.loadData);
    this.$root.$on("userDeleted", this.loadData);
    this.$root.$on("userAssigned", this.loadData);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/table/users/UsersTable.vue